module.exports = __webpack_public_path__ + "static/result-right.74577aef.png";